// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import CreateOrder from './CreateOrder';

import { IRoute } from '..';

const CreateOrderRoutes: IRoute[] = [
    {
        crumbText: 'create_order',
        component: CreateOrder,
        exact: true,
        path: '/device/createOrder',
    },
];

export default CreateOrderRoutes;
